import { render, staticRenderFns } from "./modalUrgenciaEvolucion.vue?vue&type=template&id=611b90d4"
import script from "./modalUrgenciaEvolucion.vue?vue&type=script&lang=js"
export * from "./modalUrgenciaEvolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports